/**
 * Why a file to import is refused (decision 56; part 17 log, table P, P1–P8): each is a reason the writer can be told, so
 * the import's screen (parts 18 and 24) never has to guess from an exception.
 */

/** P1–P8: the problems a file's own bytes, size or names give. */
export type ArchiveProblem = 'too-large' | 'not-zip' | 'damaged' | 'unsupported' | 'bad-name' | 'too-many-files' | 'too-big' | 'unreadable';

/** P1–P8, in table order. */
export const ARCHIVE_PROBLEMS: readonly ArchiveProblem[] = Object.freeze(['too-large', 'not-zip', 'damaged', 'unsupported', 'bad-name', 'too-many-files', 'too-big', 'unreadable']);

/** Thrown by the archive reader for a file it refuses; `problem` says why (table P), the message what it met. */
export class ArchiveError extends Error {
  override readonly name = 'ArchiveError';
  readonly problem: ArchiveProblem;

  constructor(problem: ArchiveProblem, message: string) {
    super(`${problem}: ${message}`);
    this.problem = problem;
  }
}
